import { render } from "./Detail.vue?vue&type=template&id=6766d40f&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=6766d40f&lang=less&scoped=true"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6766d40f"]])

export default __exports__